// extracted by mini-css-extract-plugin
export default {"hud":"HUD_hud__-lPst","footer":"HUD_footer__LHR9T"};